import React, { Fragment, useEffect, useState } from "react";


const ListSubscriber = () => {
  const [subscriber, setSubscriber] = useState([]);

  const getSub = async () => {
    try {
      const response = await fetch("http://zibi-admin.mvnxmobile.co.za/subapi/mvnx/info?msisdn=27610669315" , {
        method: "GET",
        mode: 'no-cors',
        headers: {
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "POST, GET, PUT",
            "Access-Control-Allow-Headers": "Content-Type",
            "Content-Type": "application/json",
        }
    }
      );


      console.log("response:");
      console.log(response);

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const jsonData = await response.json();

      console.log(jsonData);
      setSubscriber(jsonData);
    } catch (err) {
      console.error(err.message);
    } finally {
        console.log("Finally");
    }
  };

  useEffect(() => {
    getSub();
  }, []);

  console.log(subscriber);

  return (
    <Fragment>
      {" "}
    </Fragment>
  );
};

export default ListSubscriber;